export async function saveLobbyGameProgress({ token, userId, stageId, themeName, lobby_name, total_score, time_sec, answers, completed }) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/saveLobbyGameProgress`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      userId,
      ...(stageId != null && String(stageId).trim() !== "" ? { stageId } : {}),
      ...(themeName != null && String(themeName).trim() !== "" ? { themeName } : {}),
      lobby_name,
      total_score,
      time_sec,
      answers,
      // Explicit: mid-game saves must pass completed:false so the backend
      // doesn't mark the stage 'completed' before the game is actually done.
      completed: completed === true,
    }),
  });

  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) throw new Error(data.message || "Failed to save progress");
  if (data && data.success === false) throw new Error(data.message || "Failed to save progress");
  return data;
}

